import { render } from "./setCoursePlan.vue?vue&type=template&id=30c6bc6c&scoped=true"
import script from "./setCoursePlan.vue?vue&type=script&lang=js"
export * from "./setCoursePlan.vue?vue&type=script&lang=js"

import "./setCoursePlan.vue?vue&type=style&index=0&id=30c6bc6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c6bc6c"]])

export default __exports__